'use client'

import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'
import { openSelectProductPickupPointOfSaleDrawerAtom } from '@/feature/point-of-sale/services/pointOfSale.store'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Button } from '@/ui/buttons/button/Button.client'
import { gql } from '@gql-generated/gql'
import { useSetAtom } from 'jotai'
import { useMemo } from 'react'
import { createProductStocksDrawerOpenIntent } from '../../services/productStock.intent'

gql(/* GraphQL */ `
  fragment ProductStoreStockLinkProductReference on Product {
    reference
  }
`)

type StoreStockLinkProps = {
  productRef: string
  className?: string
  isReferenceTableLink?: boolean
}

export function ProductStoreStockLink({
  productRef,
  className,
  isReferenceTableLink,
}: StoreStockLinkProps) {
  const { t } = useTranslation(['productStoreStock'])

  const { config } = useSiteConfig()
  const isLocalStockByStoreEnabled = config?.pointOfSale?.isLocalStockByStoreEnabled ?? false

  const openSelectProductPickupPointOfSaleDrawerIntent = useMemo(
    () => createProductStocksDrawerOpenIntent(productRef),
    [productRef],
  )

  const openSelectProductPickupPointOfSaleDrawer = useSetAtom(
    openSelectProductPickupPointOfSaleDrawerAtom,
  )

  if (!isLocalStockByStoreEnabled) {
    return null
  }

  const eventCategory = 'fiche article / produit'

  return (
    <Button
      size="md"
      variant="link"
      className={className}
      onPress={() => {
        openSelectProductPickupPointOfSaleDrawer({
          reference: productRef,
          onClose: () => {
            pushToGtmDataLayer({
              event: 'gaEvent',
              eventCategory,
              eventAction: isReferenceTableLink
                ? 'tableau de références - drawer stock autre magasin'
                : 'drawer stock autre magasin',
              eventLabel: 'changement magasin de retrait',
            })
          },
        })

        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory,
          eventAction: isReferenceTableLink ? 'tableau de références - clic cta' : 'clic cta',
          eventLabel: 'stock autre magasin',
        })
      }}
      intent={openSelectProductPickupPointOfSaleDrawerIntent}
    >
      {t('productStoreStock:displayStoreStock')}
    </Button>
  )
}
